import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';
import { User } from 'firebase/auth';

export const createUserDocument = async (user: User, isAdmin: boolean = false) => {
  try {
    // Check if user document already exists
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    
    if (!userDoc.exists()) {
      // Create user document
      await setDoc(doc(db, 'users', user.uid), {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName || user.email?.split('@')[0] || 'Anonymous',
        mobileNumber: '', // Empty for existing users who signed up before mobile was collected
        isAdmin: isAdmin,
        createdAt: serverTimestamp(),
        lastLogin: serverTimestamp()
      });
      console.log(`User document created for ${user.email}`);
      return true;
    } else {
      console.log(`User document already exists for ${user.email}`);
      return false;
    }
  } catch (error) {
    console.error('Error creating user document:', error);
    return false;
  }
};

export const setupCurrentUser = async (user: User, makeAdmin: boolean = false) => {
  try {
    // Create user document if it doesn't exist
    await createUserDocument(user, makeAdmin);
    return true;
  } catch (error) {
    console.error('Error setting up user:', error);
    return false;
  }
}; 